<template>
    <div>
        <div>
            <div class="nav">
                <div @click="back()" class="nav_back">
                    <img src="icon/learnIcon/icon_liucheng_fanhui1.svg" alt="">
                </div>
                <div class="nav_title">免费畅学七节课</div>
                <div @click="share()" class="nav_share"></div>

            </div>

            <div class="fullSpace" style="background-image: url('freeLearn/free_bg.png');
                background-size: 100% auto;
                padding-bottom:50px;">
                <div class="free">
                    <!-- <div style="width:100%;height:190px;"></div> -->
                    <div style="background-image: url('freeLearn/video_box.png');" class="video_box">
                        <div class="play_box">
                            <div @click="play(dataItem.isPay)" v-show="isHide" class="cover">
                            </div>
                            <div v-show="isHide" class="video_title">{{ dataItem === null ? '' : dataItem.title }}</div>

                            <video class="player roundBorder4"
                               :id="tcPlayerId"
                               preload="meta"
                               playsinline="true"
                               webkit-playsinline="true"
                               x5-playsinline="true"
                               x-webkit-airplay="allow"
                               x5-video-player-type="h5"
                            ></video>
                        </div>

                    </div>
                    <!-- 查看详情课程 -->
                    <div style="background-image: url('freeLearn/course_btn.png');"
                         @click="toDetailByBizType(-1 , dataItem.vodId)" class="course_btn"></div>

                    <div class="marginT24 paddingH20">
                        <adModule :type="adTypeEnum.FREE_VOD_PAGE.code" version="4"/>
                    </div>

                </div>

                <div class="paddingH20">

                    <!-- 热点榜 -->
                    <div class="hot_box centered marginT24">
                        <div class="fullSpace roundBorder8" style="
                        border: 1px solid #FFBF4A;">
                            <div class="hot_title" style="background-image: url('freeLearn/hot_title.png');"></div>
                            <div class="content_list">
                                <div v-for="(item , index) in dataList" :key="index" class="content_item">
                                    <div class="item_left">
                                        <div class="item_img">
                                            <img :src="item.coverImg" alt="">
                                        </div>
                                        <div class="item_content">
                                            <div class="item_title">{{ item.title }}</div>
                                            <div class="item_sum">{{ item.learnCount }}人在学</div>
                                            <template v-if="user && (user.isVip === 0 || user.isCourseVip === 0)">
                                                <template v-if="item.integralValue === 0">
                                                    <div @click="selectItem(item, true)" class="item_right">
                                                        免费学
                                                    </div>
                                                </template>
                                                <template v-else-if="item.integralValue > 0 && item.isPay === true">
                                                    <div @click="selectItem(item, true)" class="item_right">
                                                        查看
                                                    </div>
                                                </template>
                                                <template v-else-if="item.integralValue > 0 && item.isPay === false">
                                                    <div @click="convert(item)" class="item_right"
                                                         style="background: linear-gradient(180deg, #FF3E39 0%, #FF6864 100%);">
                                                        <!-- <span class="unlock"></span> -->
                                                        兑换
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!-- toDetailByBizType(-1 , item.vodId) -->
                                                <div @click="selectItem(item, true)" class="item_right">
                                                    查看
                                                </div>
                                            </template>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <courseConvertDrawer ref="convertDrawer" :userTotalIntegral="userTotalIntegral"/>
    </div>
</template>
<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// modules
import courseConvertDrawer from '@comp/drawer/courseConvertDrawer.vue';
import adModule from '@comp/ad/oneImageAdModule'

// config
import appConfig from '../../appConfig';

// data
import adTypeEnum from '@/components/ad/adTypeEnum';

// api
import userApi from '@api/user';

// platformApi
import requestManager from '@comp/platformApi/requestManager';

// utils
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import consoleHelper from '@util/consoleHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';
import {toDetailByBizType} from '@comp/shixunApp/toDetail';
import windowHelper from "@util/windowHelper";

const config = {
    apiConfig: {
        list: {
            url: '/portal/v4/freeLearn/list',
            params: {
                // categoryValue : ''  // required
            },
            dataPath: 'data',
            totalPath: 'data.total',
            totalPagePath: 'data.pages',
            dataColumnMapping: {
                // userName : 'name'
            }
        }
    },
    demoTitleList: [
        '如何为做好家教工作做准备',
        '创意美术活动设计技能(大班)',
    ]
};

export default {
    name: "freeLearn",
    extends : shixunPagePart,
    components : { courseConvertDrawer, adModule },
    data() {
        return {
            adTypeEnum : adTypeEnum,
            isHide: true,
            title: '免费畅学七节课 - ' + appConfig.name + ' | ' + appConfig.desc,
            apiConfig: config.apiConfig,
            enableDataList: true,
            autoLoadDataList: true,
            scrollToLoadNextPage: false,
            tcPlayerId: "tcPlayer" + Date.now(),
            playerOptions: {
                appID: appConfig.qcloud.video.appId || '',
                fileID: "",
                // width: 735,
                // height: 400,
                controls: true, // 是否显示播放器的控制栏
                poster: "", // 设置封面图片完整地址
                autoplay: true, // 是否自动播放
            },
            videoPlayer: null,
            userTotalIntegral: 0,
            user: null,
            toDetailByBizType: toDetailByBizType,
        }
    },
    methods: {
        back() {
            appHelper.back(this);
        },
        share() {
            appHelper.showHint("点击右上角进行分享！")
        },
        play(isPay) {
            if (isPay === false) {
                appHelper.showHint('您还没兑换，无法查看哦！')
                return
            }
            this.isHide = false;
            // this.onLoadDataList();

            this.videoPlayer.play();
        },

        convert(dataItem) {
            this.openConvertDrawer({
                id: dataItem.id || '',
                vodId: dataItem.vodId || '',
                title: dataItem.title || '',
                image: dataItem.coverImg || '',
                // vodType : urlHelper.getUrlParam('vodType') || '',
                integralValue: dataItem.integralValue || ''
            });
        },
        openConvertDrawer: function (productData) {
            this.$refs.convertDrawer.setProduct(productData);
            this.$refs.convertDrawer.open();
        },

        setWechatShare: function () {

            let wechatShareOptions = {
                title: appHelper.getTitle(),
                desc: this.desc,
                link: location.href,
                imgUrl: appHelper.getAppIcon() // 分享图标
            };
            wechatHelper.setShare(wechatShareOptions);
        },

        onLoadDataList() {
            if (!this.dataList.length) {
                return;
            }

            // default item
            // const id = this.$route.params.id || '';
            // let defaultItem = arrayHelper.getItemById(this.dataList, id);
            // defaultItem ? null : defaultItem = this.dataList[0];
            let defaultItem = this.dataList[0];
            this.selectItem(defaultItem);

        },
        selectItem(dataItem, autoplay) {

            this.dataItem = dataItem;

            windowHelper.scrollTo();

            this.playerOptions.poster = dataItem.coverImg || '';
            this.playerOptions.fileID = dataItem.fileId || '';
            // this.playerOptions.fileID = '5285890808583131501';   // testing file ID
            // this.playerOptions.fileID = '5285890810139694339';   // testing file ID

            if (!this.videoPlayer) {
                this.videoPlayer = TCPlayer(this.tcPlayerId, this.playerOptions);
            } else {
                this.videoPlayer.pause();
                this.videoPlayer.loadVideoByID(this.playerOptions);
            }

            this.videoPlayer.on('error', function (error) {
                // 做一些处理
                consoleHelper.logError("error:", error);
            });

            if (autoplay) {
                this.videoPlayer.play();
            }
        },
    },
    mounted() {

        if (deviceHelper.isBrowser && browserHelper.isWechat) {
            this.setWechatShare();
        }

        //
        requestManager.request(userApi.userTotalIntegral, (error, result) => {
            if (error) {
                consoleHelper.logError(error);
                return;
            }

            if (result.errorCode) {
                appHelper.showHint(result.errorCode + ': ' + result.msg);
                consoleHelper.logError(result.errorCode + ': ' + result.msg);
                return;
            }

            this.userTotalIntegral = result.data;
        });
        appHelper.checkLogin((error, userData) => {
            if (error) {
                return;
            }
            this.user = userData;

            // 已登录情况下才执行
        });

    },

}
</script>
<style lang="scss" scoped>

.unlock {
    width: 10px;
    height: 12px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
}


.nav {
    width: 100%;
    height: 44px;
    background: #fff;
    height: 44px;
    display: flex;
    padding: 0 4%;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;

    .nav_back {
        width: 22px;
        height: 22px;
    }

    .nav_title {

        font-size: 20px;

        font-weight: 600;
        // line-height: 28px;
        color: #333333;

    }

    .nav_share {
        width: 22px;
        height: 22px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-image: url(data:image/png;base64,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);
    }
}


.free {
    //width: 100%;
    //height: 850px;
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 190px;
}


.video_box {
    margin: 0 auto;
    // padding-top: 12%;
    padding-top: 42px;
    box-sizing: border-box;
    width: 92%;
    height: 205px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}

.play_box {
    margin: 0 auto;
    width: 94%;
    height: 152px;
    position: relative;

    .cover {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        background: #000;
        opacity: .3;
    }

    .video_title {
        position: absolute;
        bottom: 11px;
        left: 12px;
        z-index: 4;
        font-size: 15px;

        font-weight: 500;
        color: #FFFFFF;
    }

    .player {
        width: 100%;
        height: 100%;
        // border: 2px solid #0879DC;
        // position: absolute;
        z-index: 2;
        // top: 0;
        // left: 0;
        // background-color: #002f4a;
    }

}


.hot_box {
    //margin: 0 auto;
    width: 92%;
    min-height: 100%;
    //margin-top: -560px;
    // margin-top: 10%;
    position: relative;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // background-clip: border-box;
    padding: 8px;


    background: linear-gradient(90deg, #FEFFD5 0%, #FFE591 100%);
    border-radius: 8px;

    .hot_title {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 142px;
        height: 29px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }
}

.course_btn {
    width: 151px;
    height: 39px;
    margin: 0 auto;
    margin-top: 3%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
}


.content_list {
    width: 94%;
    height: 100%;
    margin: 0 auto;
    padding-top: 31px;
    padding-bottom: 16px;
}

.content_item {
    width: 100%;
    // height: 74px;
    height: 13vh;
    background: #fff;
    border-radius: 4px;
    margin-top: 16px;
    display: flex;
}

.item_left {
    display: flex;
    flex: 1;
    height: 100%;

    .item_img {
        // width: 101px;
        width: 33.3%;
        height: 13vh;
        // height: 74px;
        border-radius: 4px 0px 0px 4px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 4px 0px 0px 4px;
            object-fit: cover;
        }
    }

    .item_content {
        flex: 1;
        margin-left: 8px;
        position: relative;
        overflow: hidden;
        margin-right: 5px;

        .item_title {
            position: absolute;
            top: 12px;
            left: 0;
            width: 100%;

            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;


            font-size: 14px;

            font-weight: 400;
            color: #2E303A;
        }

        .item_sum {
            position: absolute;
            bottom: 8px;
            left: 0;


            font-size: 12px;

            font-weight: 400;
            color: #9B9B9B;
        }
    }
}

.item_right {
    padding: 3px 15px;
    height: 17px;
    line-height: 17px;
    position: absolute;
    bottom: 8px;
    right: 8px;
    letter-spacing: 2.28px;
    background: linear-gradient(179deg, #FFA724 0%, #FFBB55 100%);
    border-radius: 16px;
    font-size: 14px;

    font-weight: 400;
    color: #FFFFFF;

    .unlock {
        width: 10px;
        height: 12px;
        display: inline-block;
        margin-right: 4px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAYAAAD6S912AAACH0lEQVRIS63Vy8vOaRzH8dfXMMYpQzlGZhaSmuVYiGdhoVjIxs5hEml2YxAWVv4B5pFQhKQkkpKShcPWYZJSCiWyGHJ68hBx6avrfrrd7kf3bVzL3++63tf38Pl+rtBmlVJ+wC9YiaWYiQ+4jRM4hocR8b71eLR+KKUMRQ92YgYe4DqG4HdMwS38jSsRkRcNrHbA2TWCn7Ebe/GmnhhVQWtwB6si4v6gwFLKj/gLG2qEvQmLiJKHSikZwEhsxwpswZHm1D+LsJQyDqcxrNbucQPWiKJCp+IcbuDPiOhr/G8FTsa1rE1N5+UgTRuP45iEBRHxZDDgNPyLS1jdfHMzuJSS9T2K3zAnIv4bANYUsthja1fP4io2or9dhMj9u6qclqSE8CIi+qOU8ivWYnkteNbxNV7hC53VC1JaCR2OZ8jSHMbBBO6vDbhXf3zqaBcr+5AlyMD2JPA5LmNdTfFbgKPrBE1IYAL+weaIeNtFZANbSyk/pR4xrwHcga3tgKWUrNOY1DX6vrIngfO/CqwmMQuHaoPSLO62EXte2hEwR3Fbnd/s+KZPnWxxmZpFR8C0sbk4hXdYjJutDtMxsBrCdFyowJ7mMWua785SrsA0gotNwKdtPLQr4EScrxpdFBEv/i9wRBpAHccbncrmuwq7MXp/VEPodlgas3wSE1PYB7As5YBHdSK6gSYwX8h8i/YlMF+29ViIdOJvWY9xBr0fAWmOF+oGplPtAAAAAElFTkSuQmCC);
    }
}


</style>
